import Vetting from '../src/Vetting/index.tsx';
export default Vetting;
